/**
 * Who can act on the A/B results page, and which property an action targets.
 *
 * Read-only comes from the outlet's `isShareMode` (set only by ShareLayout for
 * magic links). Every dashboard layout also passes the signed-in user's
 * `token`, so the token says nothing: treating it as "share mode" hid Stop,
 * Resume, Call and Ship from every signed-in user.
 */

import { getHttpStatus } from "@/lib/observability/shared"

export function detailReadOnly(context: { token?: string | null; isShareMode?: boolean | null }): boolean {
  return context.isShareMode === true
}

/**
 * The property an experiment action (stop, resume, archive, call, ship,
 * results goal) must go to: the experiment's own property when the list knows
 * it (workspace aggregate mode), else the page's. The backend answers 404 when
 * the experiment isn't on that property.
 */
export function experimentPropertyId(
  experiment: { propertyId?: string | null } | null | undefined,
  pagePropertyId: string | null | undefined,
): string | undefined {
  return experiment?.propertyId || pagePropertyId || undefined
}

export type LifecycleAction = "stop" | "resume" | "archive"

/** Toast copy for a failed stop / resume / archive. */
export function lifecycleErrorMessage(action: LifecycleAction, error: unknown): string {
  const status = getHttpStatus(error)
  const verb = action === "stop" ? "stop" : action === "resume" ? "resume" : "archive"
  if (status === 404) return `Couldn't ${verb} the test: it isn't on this site. Reload the page and try again.`
  if (status === 401) return `Couldn't ${verb} the test: your session expired. Sign in again.`
  if (status === 403) return `Couldn't ${verb} the test: you don't have access to this site.`
  return `Failed to ${verb} experiment`
}
